import { TypedDocumentNode, gql } from '@apollo/client';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';
import { useGetInteractionContext } from '@sorare/core/src/hooks/useGetInteractionContext';

import {
  lockProModeMutation,
  lockProModeMutationVariables,
} from './__generated__/index.graphql';

const LOCK_PRO_MODE_MUTATION = gql`
  mutation lockProModeMutation($input: lockProModeInput!) {
    lockProMode(input: $input) {
      currentUser {
        slug
        forcedIntoOnboarding(sport: FOOTBALL)
        anyUserSportProfile(sport: FOOTBALL) {
          id
          ... on FootballUserSportProfile {
            id
            proUnlocked
          }
        }
      }
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<lockProModeMutation, lockProModeMutationVariables>;

const RelockPro = () => {
  const { footballUserProfile } = useCurrentUserContext();
  const getInteractionContext = useGetInteractionContext();
  const proUnlocked = footballUserProfile?.proUnlocked;
  const [lockProMode] = useMutation(LOCK_PRO_MODE_MUTATION, {
    showErrorsWithSnackNotification: true,
  });
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const relockPro = async () => {
      if (proUnlocked) {
        await lockProMode({
          variables: {
            input: {
              sport: Sport.FOOTBALL,
              interactionContext: getInteractionContext(),
            },
          },
        });
        searchParams.delete('relock');
        setSearchParams(searchParams, {
          replace: true,
        });
      }
    };
    relockPro();
  }, [
    proUnlocked,
    getInteractionContext,
    lockProMode,
    searchParams,
    setSearchParams,
  ]);
  return null;
};

export const MaybeRelockPro = () => {
  const [searchParams] = useSearchParams();
  const relock = searchParams.get('relock');
  if (relock) {
    return <RelockPro />;
  }
  return null;
};
